/**
 * The scroll-to-top sentinel's id, shared by the Server Component that renders the sentinel and the
 * client control that scrolls to it. Kept out of the `.client.tsx` module: a server import from
 * there receives a client reference, not the string.
 */
export const CHANNEL_LINEUP_TOP_ANCHOR_ID = "channel-lineup-top";
